<template>
    <div>
        <!--Control Component -->

        <b-input-group @click="openMoal()" v-if="isModal">
            <b-form-input readonly :value="sectionString" class="me-2"></b-form-input>
            <div>
                <b-button v-b-modal.locationSubModal variant="outline-info">
                    <b-icon icon="arrows-angle-expand"></b-icon>
                </b-button>
            </div>
        </b-input-group>

        <!--Modal Component -->
        <b-modal v-if="isModal" v-model="is_visible" no-close-on-backdrop :title="modalTitle" title-class="p-2"
            header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap"
            hide-footer size="lg">
            <portal-target name="locationSectionComp"></portal-target>
        </b-modal>

        <!--Section Component -->
        <portal to="locationSectionComp" :disabled="!isModal || !is_visible" v-show="!isModal || is_visible">
            <b-card :title="title" title-tag="h6">
                <div v-show="searchMode">
                    <b-row class="filter-form">
                        <b-col cols="12" md="7" class="p-0">
                            <vue-typeahead-bootstrap v-model="searchedLocationName" @queryOptionsValue="queryOptionsValue"
                                inputClass="lh-base" :data="searchedLocations" :serializer="s =>
                                    s.address1 +
                                    ', ' +
                                    s.address2 +
                                    ', ' +
                                    s.city
                                    " @hit="getSearchedLocation" @input="lookupSearchedLocations"
                                :placeholder="$translate('search_saved_address')" />
                        </b-col>
                        <b-col cols="4" md="2" sm="3" class="mt-2 mt-md-0 px-0 px-md-3">
                            <b-button :disabled="!isLocation" class="text-nowrap" variant="info"
                                @click="setSearchedLocation()">{{ $translate('use_address') }}</b-button>
                        </b-col>
                        <b-col cols="4" md="3" sm="3" class="mt-2 mt-md-0">
                            <b-button block variant="info" class="text-nowrap" @click="setCreateLocationMode">{{
                                $translate('create_location') }}</b-button>
                        </b-col>
                    </b-row>
                </div>
                <!-- {{ sectionOnly  }} -->

                <location-view v-show="!searchMode" :required="required" :location-data="location"
                    :section-only="sectionOnly" :disabled="disabled" :hide-controls="true" :loading="loading"
                    @cancel="$emit('cancel')" @update-location-model="triggerUpdateLocation">
                    <template #default>
                        <b-button :disabled="disabled" v-if="!hideControls" class="mr-2 mt-2" variant="info"
                            @click="setSearchMode">{{ $translate('change_location') }}</b-button>
                        <slot :hide-modal="hideModal" :set-location="setLocation" :set-search-mode="setSearchMode"></slot>
                    </template>
                    <template #section>
                        <b-col cols="12" class="mb-4">
                            <label class="mb-4"><strong>{{ $translate('section_name') }}</strong>
                            </label>
                            <b-form-input id="section-name" v-model="section_name" :readonly="disabled"
                                :placeholder="$translate('enter_section_name')"></b-form-input>
                        </b-col>
                    </template>
                </location-view>
            </b-card>
        </portal>
    </div>
</template>

<script>
import EventBus from '@/exports/event-bus.js'
import VueTypeaheadBootstrap from '@/components/VueTypeAhead/VueTypeaheadBootstrap'

import { debounce } from 'lodash'
import LocationView from './LocationView'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'LocationSection',
    components: { LocationView, VueTypeaheadBootstrap },
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            mounting: false,
            filters: {},
            currentSection: { name: '', location: {} },
            section_name: '',
            searchMode: false,
            setNewLocation: {},
            searchedLocationName: '',
            location: null,
            is_visible: false,
            isLocation: false
        }
    },

    props: {
        sectionOnly: { type: Boolean },
        value: { type: Number },
        hideControls: { type: Boolean },
        title: { type: String },
        disabled: { type: Boolean },
        loading: { type: Boolean },
        modalTitle: { type: String },
        isModal: { type: Boolean },
        required: { type: Boolean },
        section_data: { type: Object, default: null }
    },
    computed: {
        searchedLocations() {
            const searchedLocations = this.$store.state.locations.locations
            console.log('searchedLocations', searchedLocations)
            return searchedLocations
        },

        sectionString() {
            const { section_name, location } = this
            let { address1, address2 } = location || {}
            address1 = address1 || ''
            address2 = address2 || ''
            return address1 || address2
                ? `${section_name ? section_name + ', ' : ''}${address1 && address2
                    ? address1 + ', ' + address2
                    : address1
                        ? address1
                        : address2
                }`
                : this.$translate('asset_location_placeholder')
        },
    },
    watch: {
        sectionString: function (to, from) {
            console.log('watch sectionString', { to, from })
        },
        ///////////////////////

        'currentSection.id': function (to, from) {
            console.log('watch current section id', { to, from })
            this.$emit('input', to)
        },

        section_name: function (section_name, from) {
            const { location, currentSection } = this
            console.log('current section name', {
                section_name,
                from,
            })

            if (
                section_name &&
                section_name ==
                (currentSection && currentSection.id && currentSection.name)
            ) {
                this.$emit('input', currentSection.id)
            } else {
                this.$set(this.currentSection, 'id', null)
                this.$emit('input', null)
            }

            this.$emit('update-section-model', {
                section_name,
                location,
            })
        },

        'currentSection.location': {
            handler: function (_location) {
                const { location } = this
                this.$emit('searchMode', this.searchMode)
                console.log('watch currentSection.location', _location)
                if ((_location && _location.id) || (location && location.id)) {
                    this.parseLocation(
                        _location,
                        'currentSection location watch'
                    )
                }
            },
            deep: true,
        },

        //////////////////////////////////

        location: {
            handler: function (location, from) {
                console.log(this.isDeepEqual(location, from), '--watching')
                if(!this.isDeepEqual(location, from)){
                    console.log('location --watching', { location, from })
                    const { section_name } = this
                    this.$emit('update-section-model', { section_name, location })
                }
            },
            deep: true,
        },

        value: function (to, from) {
            console.log('value--watching', { to, from })
            this.setSection(to)
        },
    },
    created() {
        EventBus.$on('set-location-search-mode', () => {
            this.setSearchMode()
        })
    },
    async mounted() {
        if(this.section_data == null){
            console.log('locationSection---mounting')
            await this.setSection(this.value, true)
            this.$emit('searchMode', this.searchMode)
        } else {
            this.currentSection = this.section_data
            this.section_name = this.section_data.name
            this.searchMode = false
        }
    },
    methods: {
        openMoal() {
            if (this.sectionString == 'Click to Select Location') {
                this.is_visible = true; this.searchMode = true
            } else {
                this.is_visible = true;
            }
        },
        hideModal() {
            this.is_visible = false
        },
        setLocation() {
            this.is_visible = false
            this.genericToast(
                this.$translate('location_section'),
                this.$translate('added'),
                'success',
                `${this.$translate('location_section')} ${this.$translate('add_alert')} `
            )
        },
        queryOptionsValue(val) {
            console.log("gettttt", val)
            this.filters.queryOptionsValue = val
            this.lookupSearchedLocations()
        },
        lookupSearchedLocations: debounce(function () {
            // in practice this action should be debounced
            const { searchedLocationName: query ,filters } = this
            this.$store.dispatch('locations/fetchAllLocations', {query, filters })
        }, 500),

        resetCurrentSection() {
            for (let key in this.currentSection) {
                if (key == 'name') {
                    this.$set(this.currentSection, 'name', '')
                    this.section_name = ''
                } else if (key == 'location')
                    this.$set(this.currentSection, 'location', {})
                else this.$delete(this.currentSection, key)
            }
        },

        setSearchMode() {
            this.searchedLocationName = ''
            this.resetCurrentSection()
            this.searchMode = true
        },
        setCreateLocationMode() {
            this.resetCurrentSection()
            this.searchMode = false
        },

        getSearchedLocation(location) {
            this.setNewLocation = location
            this.isLocation = true
        },
        setSearchedLocation() {
            this.currentSection = this.currentSection || { name: '' }
            this.$set(this.currentSection, 'location', this.setNewLocation)
            this.searchMode = false
            this.isLocation = false
        },

        async setSection(id) {
            console.log('setSection----id', id)
            if (id) {
                const section = await this.$store.dispatch(
                    'locations/getSection',
                    id
                )

                this.currentSection = section
                this.section_name = section.name
                this.searchMode = false
            }
        },
        parseLocation(
            {
                id,
                name,
                address1,
                address2,
                city,
                postal_code,
                state_name,
                zip_code,
                country_code,
                latitude,
                longitude,
                // map_reference,
                is_warehouse,
            },
            trigger
        ) {
            console.log('parseLocation trigger', trigger)
            this.location = {
                id,
                name,
                address1,
                address2,
                city,
                state_name,
                zip_code,
                postal_code,
                country_code,
                latitude,
                longitude,
                // map_reference,
                is_warehouse,
            }
        },

        triggerUpdateLocation(_location) {
            const {
                currentSection: { location, id, name },
            } = this
            if (!_location.id || _location.id != (location && location.id)) {
                if (location || id || name) {
                    this.$set(this.currentSection, 'id', null)
                    this.$set(this.currentSection, 'name', '')
                    this.$set(this.currentSection, 'location', null)
                }
                this.parseLocation(_location, 'triggerUpdateLocation')
            } else {
                this.parseLocation(_location, 'triggerUpdateLocation')
            }

            console.log('triggerUpdateLocation', _location)
        },
    },
}
</script>
